//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../../library/umum'
import FETCHING from  '../../../../library/fetching'
import WILAYAH from  '../../../../library/getWilayah'
import uniqid from 'uniqid';

export default {
  props: ["id_bumDes"],
  data() {
    return {

        form : {
            id : '',
            id_bumDes : this.id_bumDes,
            jenis_usaha : '',
            file : null,
            omset : '',
            pendapatan : '',
            lokasi : '',
            status : '',

            createdAt : '',
            des_kel : '',
        },

        modal : {
            id : '',
            id_bumDes : this.id_bumDes,
            sumber : '',
            tahun : '',
            jumlah : '',
            createdAt : '',
            des_kel : '',
        },

        laporan : {
            id : '',
            id_bumDes : this.id_bumDes,
            uraian : '',
            tahun : '',
            file : null,
            createdAt : '',
            des_kel : '',
        },

        kerjaSama : {
            id : '',
            id_bumDes : this.id_bumDes,
            uraian : '',
            tahun : '',
            file : null,
            createdAt : '',
            des_kel : '',
        },


        pendampingan : {
            id : '',
            id_bumDes : this.id_bumDes,
            lembaga : '',
            waktu : '',
            tahun : '',
            createdAt : '',
            des_kel : '',
        },

        intensitas : {
            id : '',
            id_bumDes : this.id_bumDes,
            rapat : '',
            jml_tenaga : '',
            kontribusi : '',
            createdAt : '',
            des_kel : '',
        },


        fileOld : '',


        list_data : [],
        list_pendidikan : [],
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat : false,


        mdl_add_modal: false,
        mdl_edit_modal: false,
        mdl_hapus_modal : false,

        mdl_add_laporan: false,
        mdl_edit_laporan: false,
        mdl_hapus_laporan : false,
        mdl_lihat_laporan : false,

        mdl_add_kerjaSama: false,
        mdl_edit_kerjaSama: false,
        mdl_hapus_kerjaSama : false,
        mdl_lihat_kerjaSama : false,

        mdl_add_pendampingan: false,
        mdl_edit_pendampingan: false,
        mdl_hapus_pendampingan : false,


        FETCHING : FETCHING,
    }
  },
  methods: {


    getView : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_usahaKeuangan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.form.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.$store.state.list_usahaKeuangan = res_data;

      });
    },


    addData : function(number) {

      var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("id_bumDes", this.form.id_bumDes);
        formData.append("jenis_usaha", this.form.jenis_usaha);
        formData.append("omset", this.form.omset);
        formData.append("pendapatan", this.form.pendapatan);
        formData.append("lokasi", this.form.lokasi);
        formData.append("status", this.form.status);

        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.form.file);


        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_usahaKeuangan", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData : function(){

      var formData = new FormData();
      formData.append("id", this.form.id);
      formData.append("id_bumDes", this.form.id_bumDes);
      formData.append("jenis_usaha", this.form.jenis_usaha);
      formData.append("omset", this.form.omset);
      formData.append("pendapatan", this.form.pendapatan);
      formData.append("lokasi", this.form.lokasi);
      formData.append("status", this.form.status);
      formData.append("createdAt", this.form.createdAt);
      formData.append("file", this.form.file);

      formData.append("fileOld", this.fileOld);


      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_usahaKeuangan", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_usahaKeuangan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.form.id,
              fileOld : this.fileOld,
          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){

            this.form.id = data.id;
            this.form.jenis_usaha = data.jenis_usaha;
            this.form.omset = data.omset;
            this.form.pendapatan = data.pendapatan;
            this.form.lokasi = data.lokasi;
            this.form.status= data.status;
            this.form.createdAt = data.createdAt;
            this.fileOld = data.file;

    },


// ======================================= MODAL // =======================================
    getView_modal : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_keuangan_modal", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.form.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.$store.state.list_keuangan_modal = res_data;
      });
    },


    addData_modal : function(number) {
        this.modal.id = uniqid();
        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_keuangan_modal", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.modal)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_modal();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_modal : function(){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_keuangan_modal", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.modal)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_modal();
      });
    },

    removeData_modal : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_keuangan_modal", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.modal)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_modal();
      });

    },

    selectData_modal : function(data){

            this.modal.id = data.id;
            this.modal.sumber = data.sumber;
            this.modal.tahun = data.tahun;
            this.modal.jumlah= data.jumlah;
            this.modal.createdAt = data.createdAt;
    },

// ======================================= MODAL // =======================================





// ======================================= LAPORAN // =======================================
    getView_laporan : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_keuangan_laporan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.laporan.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.$store.state.list_keuangan_laporan = res_data;

      });
    },


    addData_laporan : function(number) {
  
        var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("id_bumDes", this.laporan.id_bumDes);
        formData.append("uraian", this.laporan.uraian);
        formData.append("tahun", this.laporan.tahun);


        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.laporan.file);


        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_keuangan_laporan", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_laporan();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_laporan : function(){

      var formData = new FormData();
      formData.append("id", this.laporan.id);
      formData.append("id_bumDes", this.laporan.id_bumDes);
      formData.append("uraian", this.laporan.uraian);
      formData.append("tahun", this.laporan.tahun);
      formData.append("createdAt", this.laporan.createdAt);
      formData.append("file", this.laporan.file);

      formData.append("fileOld", this.fileOld);


      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_keuangan_laporan", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_laporan();
      });
    },

    removeData_laporan : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_keuangan_laporan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.laporan.id,
              fileOld : this.fileOld,
          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_laporan();
      });

    },

    selectData_laporan : function(data){

            this.laporan.id = data.id;
            this.laporan.uraian = data.uraian;
            this.laporan.tahun = data.tahun;
            this.laporan.createdAt = data.createdAt;
            this.fileOld = data.file;

    },

// ======================================= LAPORAN // =======================================




// ======================================= KERJASAMA // =======================================
    getView_kerjaSama : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_keuangan_kerjaSama", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.kerjaSama.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.$store.state.list_keuangan_kerjaSama = res_data;

      });
    },


    addData_kerjaSama : function(number) {
  
        var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("id_bumDes", this.kerjaSama.id_bumDes);
        formData.append("uraian", this.kerjaSama.uraian);
        formData.append("tahun", this.kerjaSama.tahun);


        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.kerjaSama.file);


        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_keuangan_kerjaSama", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_kerjaSama();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_kerjaSama : function(){

      var formData = new FormData();
      formData.append("id", this.kerjaSama.id);
      formData.append("id_bumDes", this.kerjaSama.id_bumDes);
      formData.append("uraian", this.kerjaSama.uraian);
      formData.append("tahun", this.kerjaSama.tahun);
      formData.append("createdAt", this.kerjaSama.createdAt);
      formData.append("file", this.kerjaSama.file);

      formData.append("fileOld", this.fileOld);


      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_keuangan_kerjaSama", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_kerjaSama();
      });
    },

    removeData_kerjaSama : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_keuangan_kerjaSama", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.kerjaSama.id,
              fileOld : this.fileOld,
          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_kerjaSama();
      });

    },

    selectData_kerjaSama : function(data){

            this.kerjaSama.id = data.id;
            this.kerjaSama.uraian = data.uraian;
            this.kerjaSama.tahun = data.tahun;
            this.kerjaSama.createdAt = data.createdAt;
            this.fileOld = data.file;

    },

// ======================================= KERJASAMA // =======================================



// ======================================= PENDAMPINGAN // =======================================
    getView_pendampingan : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_keuangan_pendampingan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.form.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.$store.state.list_keuangan_pendampingan = res_data;
      });
    },


    addData_pendampingan : function(number) {
        this.modal.id = uniqid();
        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_keuangan_pendampingan", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pendampingan)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_pendampingan();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_pendampingan : function(){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_keuangan_pendampingan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.pendampingan)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_pendampingan();
      });
    },

    removeData_pendampingan : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_keuangan_pendampingan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.pendampingan)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_pendampingan();
      });

    },

    selectData_pendampingan : function(data){

            this.pendampingan.id = data.id;
            this.pendampingan.lembaga = data.lembaga;
            this.pendampingan.waktu = data.waktu;
            this.pendampingan.tahun = data.tahun;
            this.pendampingan.createdAt = data.createdAt;
    },

// ======================================= PENDAMPINGAN // =======================================



// ======================================= INTENSITAS // =======================================
    getView_intensitas : function(){

      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "view_keuangan_intensitas", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_bumDes: this.form.id_bumDes,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.$store.state.list_keuangan_intensitas = res_data;
      });
    },


    addData_intensitas : function(number) {
        this.modal.id = uniqid();
        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "addData_keuangan_intensitas", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.intensitas)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_intensitas();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_intensitas : function(){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "editData_keuangan_intensitas", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.intensitas)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_intensitas();
      });
    },

    removeData_intensitas : function(E){
      fetch(this.$store.state.url.URL_srv_bumdes_kelembagaan + "removeData_keuangan_intensitas", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.intensitas)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_intensitas();
      });

    },

    selectData_intensitas : function(data){

            this.intensitas.id = data.id;
            this.intensitas.rapat = data.rapat;
            this.pendampingan.jml_tenaga = data.jml_tenaga;
            this.intensitas.kontribusi = data.kontribusi;
            this.intensitas.createdAt = data.createdAt;
    },

// ======================================= INTENSITAS // =======================================







    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


        getList : async function(){
          this.list_pendidikan = await FETCHING.FETCH_GET(this.$store.state.url.URL_DATAMASTER_PENDIDIKAN);
        },




    // ====================================== PAGINATE ====================================







  },

  mounted () {
    // this.FETCHING.postPendidikan()
    this.getView();
    this.getView_modal();
    this.getView_laporan();
    this.getView_kerjaSama();
    this.getView_intensitas();

      
  },
}
